import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Preview from "../views/Preview.vue";
import CommonList from "../views/CommonList.vue";
import RankList from "../views/RankList.vue";
import PersonalHomePage from "../views/PersonalHomePage.vue";
import HomePage from "../views/HomePage.vue";
import Emptyview from "../views/Emptyview.vue";
import Cookies from "js-cookie";
// import api from "../api";
import { Dialog } from "@vant/compat";

const routes = [
  {
    path: "/:id",
    name: "Home",
    component: Home
    // meta: { requiresAuth: false }
  },
  {
    path: "/preview/:previewId",
    name: "Preview",
    component: Preview
    // meta: { requiresAuth: true }
  },
  {
    path: "/commonList/:id",
    name: "commonList",
    component: CommonList
    // meta: { requiresAuth: false }
  },
  {
    path: "/rankList",
    name: "rankList",
    component: RankList
    // meta: { requiresAuth: false }
  },
  {
    path: "/personalHome",
    name: "personalHome",
    component: PersonalHomePage
    // meta: { requiresAuth: false }
  },
  {
    path: "/homePage/:id",
    name: "homePage",
    component: HomePage
    // meta: { requiresAuth: false }
  },
  {
    path: "/emptyview",
    name: "Emptyview",
    component: Emptyview
    // meta: { requiresAuth: false }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  // codeStart 判断是否显示维护提示
  // const start = "2026/1/8 01:00:00";
  // const end = "2026/1/8 03:00:00";

  // const time =
  //   Date.parse(start) < new Date().getTime() &&
  //   Date.parse(end) > new Date().getTime();
  // if (time && to.path != "/emptyview") {
  //   sessionStorage.setItem("emptyToRedirectUrl", to.fullPath);
  //   next("/emptyview");
  //   return;
  // }
  // if (!time && to.path == "/emptyview") {
  //   const emptyToRedirectUrl = sessionStorage.getItem("emptyToRedirectUrl");
  //   sessionStorage.removeItem("emptyToRedirectUrl");
  //   next(emptyToRedirectUrl || "/");
  //   return;
  // }
  // codeEnd

  const userAgentString = navigator.userAgent.toLowerCase();
  if (to.name === "Preview") {
    console.log("进入预览页面");
    const preview_token = Cookies.get("preview_token"); // 使用场景：可以直接从文章页跳转活动页，不需要在跳转活动页之前授权
    if (!preview_token) {
      // 微信授权获取用户信息指定的路径
      const basePath = process.env.VUE_APP_PublicPath;
      let redirect_uri = encodeURIComponent(
        `https://zsrbapp.zsnews.cn${basePath}/#${to.fullPath}`
      );
      window.location.href = `https://zsplus-fastapi.zsnews.cn/api/plus/auth/wechat/h5-v2/oauth?redirect=${redirect_uri}&grant=preview`;
    } else {
      next();
    }
  }
  // 中山+环境
  else if (userAgentString.indexOf("zsrbapp") >= 0) {
    console.log("进入中山+环境");

    if (sessionStorage.getItem("session_token")) {
      next();
    } else {
      try {
        window.ZsrbApp.call("userInfo", { isNeedBind: 0 }, (res) => {
          const info = JSON.parse(res);
          const sessionToken = info.sessionToken || null;
          if (sessionToken) {
            // 设置 session_token 到 sessionStorage
            sessionStorage.setItem("session_token", sessionToken);
            next();
          } else {
            // 个人主页强制登录
            if (to.name === "personalHome") {
              window.ZsrbApp.call("login", {}, (res) => {
                const info = JSON.parse(res);
                if (info.status == "1") {
                  sessionStorage.setItem("session_token", info.sessionToken);
                  next();
                } else {
                  Dialog.alert({
                    message: "当前未登录状态，请重新登录"
                  }).then(() => {
                    window.ZsrbApp.call("back", {}, null);
                  });
                }
              });
            } else {
              next();
            }
          }
        });
      } catch (e) {
        next(); // 兜底
      }
    }
  }

  // 判断在微信环境且非企业微信
  else if (
    userAgentString.indexOf("micromessenger") >= 0 &&
    userAgentString.indexOf("wxwork") < 0 &&
    userAgentString.indexOf("miniprogram") < 0
  ) {
    console.log("进入微信环境！！！");
    const token = Cookies.get("token"); // 使用场景：可以直接从文章页跳转活动页，不需要在跳转活动页之前授权
    if (!token) {
      // 微信授权获取用户信息指定的路径
      const basePath = process.env.VUE_APP_PublicPath;
      let redirect_uri = encodeURIComponent(
        `https://zsrbapp.zsnews.cn${basePath}/#${to.fullPath}`
      );
      window.location.href = `https://zsrbactivity.zsnews.cn/api/wechat/oauth?redirect=${redirect_uri}`;
    } else {
      next();
    }
  } else {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    next();
  }
});

router.afterEach(() => {
  window.TrackKit.umengAdapter.trackPageView();
});
export default router;
